/**
 * Convert mono, 16-bit PCM audio to a Float32Array.
 *
 * @param pcmArrayBuffer - The PCM audio data as an ArrayBuffer
 * @returns The audio data as a Float32Array.
 */
export const pcm16BitToFloat = (pcmArrayBuffer: ArrayBuffer): Float32Array => {
  // TODO: Ensure endianess is handled correctly
  const dataView = new DataView(pcmArrayBuffer);
  const float32Array = new Float32Array(pcmArrayBuffer.byteLength / 2); // Each 16-bit sample takes 2 bytes
  let offset = 0;

  for (let i = 0; i < float32Array.length; i++, offset += 2) {
    const int16 = dataView.getInt16(offset, true); // Read 16-bit PCM sample
    float32Array[i] = int16 / 0x8000; // Normalize to range [-1, 1]
  }

  return float32Array;
};
